import { yupResolver } from '@hookform/resolvers/yup';
import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/custom-toast.css';
import InputCadastro from '../../../components/form/InputCadastro';
import { toast } from 'react-toastify';
import Input from '../../../components/form/InputComLabel';
import InputCpf from '../../../components/form/InputCpf';
import InputIdCorreios from '../../../components/form/InputIdCorreios';
import InputRazaoSocial from '../../../components/form/InputRazaoSocial';
import InputSenha from '../../../components/form/InputSenha';
import InputToken from '../../../components/form/InputToken';
import useFetch from '../../../components/hooks/useFetch';
import { abreAlertaDialog } from '../../../components/modal/AlertaDialog';
import { getIPAddress } from '../../../components/utils/GetIPAddress';
import {
  ALTERAR_SENHA,
  ALTERAR_SENHA_RESET,
  ENVIAR_TOKEN_PJ,
  ESQUECI_SENHA_PJ,
  GET_TELEFONE_INTERNACIONAL,
} from '../../../services/cadastro';
import './esqueciSenha.css';
import { createFormSchemas } from './FormSchema';
import { useLocation } from "react-router-dom";
import { AuthContext } from '../../../store/AuthContext';


const EsqueciSenhaPJ = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { newSession } = useContext(AuthContext);
  const { formEsqueciSenhaPJ } = createFormSchemas(t);
  const methods = useForm({ resolver: yupResolver(formEsqueciSenhaPJ) });
  const [modalAbertoToken, setModalAbertoToken] = useState(false);
  const [meioEnvio, setMeioEnvio] = useState();
  const [senhaEnvio, setSenhaEnvio] = useState();
  const [idCorreiosEnvio, setIdCorreiosEnvio] = useState();
  const [ipAddress, setIpAddress] = useState('');
  const [tenhoCnpj, setTenhoCnpj] = useState('1');
  const [meioEnvioSelecionado, setMeioEnvioSelecionado] = useState('E');
  const [desabilitarCelular, setDesabilitarCelular] = useState(false);
 // const [cpfRepresentanteLegal, setCpfRepresentanteLegal] = useState();
 // const [dataNascRepresentanteLegal, setDataNascRepresentanteLegal] = useState();

  const location = useLocation();
  const isResetSnh = location.state?.resetsnh;
  const searchParams = new URLSearchParams(location.search);
  const isExpiredPassword = searchParams.get('expiredPassword') === 'true';
  const exibirMensagemPreventiva = isResetSnh || isExpiredPassword;

  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);

  const { request } = useFetch();

  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };

  const handleMeioEnvioChange = (event) => {
    const valor = event.target.value;
    if (valor === 'C' && desabilitarCelular) {
      return;
    }
    setMeioEnvioSelecionado(valor);
    methods.setValue('meioEnvio', valor);
  };

  const handleBlurIdCorreios = async (event) => {
    const idCorreios = (event?.target?.value || '').replace(/[\/\?/||(]/g, '');
    const forcarEmailETravarCelular = () => {
      setDesabilitarCelular(true);
      setMeioEnvioSelecionado('E');
      methods.setValue('meioEnvio', 'E');
    };

    if (!idCorreios) {
      setDesabilitarCelular(false);
      return null;
    }

    try {
      const { response, json } = await request(
        GET_TELEFONE_INTERNACIONAL(idCorreios),
      );
      if (!response?.ok) {
        forcarEmailETravarCelular();
        return null;
      }

      const valor =
        typeof json === 'string'
          ? json
          : json?.internacional || json?.valor || json?.status || null;

      const bloquearCelular = String(valor || '').toUpperCase() === 'S';
      setDesabilitarCelular(bloquearCelular);
      if (bloquearCelular) {
        forcarEmailETravarCelular();
      }

      return valor;
    } catch (error) {
      forcarEmailETravarCelular();
      return null;
    }
  };
  var idCorreios;

  const handleSubmit = async (data) => {

    var meioEnvioEnviar = methods.getValues('meioEnvio');
    if (!meioEnvioEnviar) {
      meioEnvioEnviar = 'E';
    }
     
    setMeioEnvio(meioEnvioEnviar);
    idCorreios = methods.getValues('idCorreios').replace(/[\\/\\?/||(]/g, '');
    setIdCorreiosEnvio(idCorreios);
    setSenhaEnvio(methods.getValues('novaSenha'));
   
    //var cpfRepresentanteLegal =  data.cpf.replace(/[.-]/g, ''); 
    //setCpfRepresentanteLegal(cpfRepresentanteLegal);     
     
    var formattedDate = null;
    if (data.dataNascimento) {
      const dataNasc = new Date(data.dataNascimento);
      const yyyy = dataNasc.getFullYear();
      const mm = String(dataNasc.getMonth() + 1).padStart(2, '0');
      const dd = String(dataNasc.getDate()).padStart(2, '0');
      formattedDate = `${yyyy}-${mm}-${dd}`;      
    }   
    //setDataNascRepresentanteLegal(formattedDate);
   
    let reset = false;
    if (exibirMensagemPreventiva) {
      reset = true;
    } 

    const dados = {
      idCorreios,
      nome: data.nome.toUpperCase(),
      //nomeFantasia: data.nomeFantasia,
      //senha: senhaEnvio,
      novaSnh: data.novaSenha,
      meioEnvio: meioEnvioEnviar,
      reset: reset,
      //dataNascRepresentanteLegal: formattedDate,
      //cpfRepresentanteLegal,
     ...(formattedDate && tenhoCnpj ==="1" && {dataNascRepresentanteLegal: formattedDate}),
     ...(data.cpf && tenhoCnpj ==="1" && {cpfRepresentanteLegal:data.cpf.replace(/[.-]/g, '')}),
     ...(data.an8 && { an8: data.an8 }),
     ...(data.numeroContrato && { numeroContrato: data.numeroContrato }),
    };
       
    const { response, json } = await request(ESQUECI_SENHA_PJ(dados, ipAddress));

    if (response.ok) { 
      const valorMascarado = json?.valor ? ` ${aplicarMascara(json.valor, meioEnvioEnviar)}` : '';    
      if (meioEnvioEnviar == 'E') {
        abreAlertaDialog(t('cadastro.messages.success.token_sent_email').replace(/\.$/, '') + valorMascarado + '.');
      } else {
        abreAlertaDialog(t('cadastro.messages.success.token_sent_mobile').replace(/\.$/, '') + valorMascarado + '.');
      }
      openModalToken();
    }
  };

  const openModalToken = () => {
    setModalAbertoToken(true);
  };
  const fecharToken = (ev) => {
    ev.preventDefault();
    setModalAbertoToken(false);
  };  

  const reenviaToken = async () => {
    let func = 'ESQUECEU_SENHA'
    if (exibirMensagemPreventiva) {
      func = 'SENHA_REDEFINICAO_RESET'
    }
    const token = {
      meioEnvio: meioEnvio,
      funcionalidade: func,
    };
    const { response, json } = await request(
      ENVIAR_TOKEN_PJ(idCorreiosEnvio, token, ipAddress),
    );
    if (response.ok) {
      const valorMascarado = json?.valor ? ` ${aplicarMascara(json.valor, meioEnvio)}` : '';
      if (meioEnvio == 'E') {
        abreAlertaDialog(t('cadastro.messages.success.token_sent_email').replace(/\.$/, '') + valorMascarado + '.');
      } else {
        abreAlertaDialog(t('cadastro.messages.success.token_sent_mobile').replace(/\.$/, '') + valorMascarado + '.');
      }
      openModalToken();
    }
  };

  const alterar = async () => {
    const token1 =
      document.getElementById('confirmarSenha1').value +
      document.getElementById('confirmarSenha2').value +
      document.getElementById('confirmarSenha3').value +
      document.getElementById('confirmarSenha4').value +
      document.getElementById('confirmarSenha5').value +
      document.getElementById('confirmarSenha6').value;
    if (token1.length < 6) {
      abreAlertaDialog(t('cadastro.messages.validation.token_required'));
    } else {
      const senhaEnviar = {
        senha: senhaEnvio,
        token: token1,
        idCorreios: idCorreiosEnvio,
      };
      let response;
      if (exibirMensagemPreventiva) {
        ({ response } = await request(ALTERAR_SENHA_RESET(senhaEnviar, ipAddress)));
      } else {
        ({ response } = await request(ALTERAR_SENHA(senhaEnviar, ipAddress)));
      }

      if (response.ok) {
        abreAlertaDialog(t('cadastro.messages.success.password_reset'));
        navigate('/login');
      }
    }
  };
  const aplicarMascara = (valor, tipo) => {
    if (tipo === 'E') {
      return mascararEmail(valor);
    } else if (tipo === 'C') {
      return mascararTelefone(valor);
    }
    return valor;
  };
  const mascararEmail = (email) => {
    if (email) {
      const [usuario, dominio] = email.split('@');
      const usuarioMascarado = usuario.slice(0, 3) + 'xxx';
      return `${usuarioMascarado}@${dominio}`;
    } else {
      return '';
    }
  };
  const mascararTelefone = (telefone) => {
    if (telefone) {
      const digitos = telefone.replace(/\D/g, '');
      if (digitos.length === 11) {
        const ddd = digitos.slice(0, 2);
        const ultimos4 = digitos.slice(-4);
        return `(${ddd}) XXXX-${ultimos4}`;
      }
      return telefone;
    } else {
      return '';
    }
  };
  const [perfil, setPerfil] = React.useState('');
  const handleOptionChange = (event) => {
    setPerfil(event.target.value);
  };
  const handleTenhoCnpj = (event) => {
    setTenhoCnpj(event.target.value);
  };
  return (
    <>
      {!modalAbertoToken ? (
        <div className="conteudo">
          <div id="recuperar-senha" className="card bg-superficie elev5">
            <img
              alt={t('cadastro.accessibility.carol_image')}
              id="img-carol-boasvindas"
              src="/images/carol-perfil.png"
            />
            {!exibirMensagemPreventiva && 
              <h1>{t('cadastro.titles.forgot_password')}</h1>
            }

            {exibirMensagemPreventiva && 
              <>
                <h1> 
                  {t('cadastro.titles.important')}: <br />
                  {t('cadastro.titles.change_password')} 
                </h1>
                <h5><b>
                  <center>
                    <font color="#6d6d6d">
                      Como medida preventiva para proteger seus dados de 
                      cadastro e o acesso aos nossos sistemas, solicitamos que 
                      você altere sua senha. Essa ação ajuda a manter sua conta 
                      segura e evitar acessos indevidos.
                    </font>
                  </center>
                </b></h5>
              </>
            }

            <label htmlFor="idCorreios">
              <h5>{t('cadastro.messages.info.login_instructions_pj')}</h5>
            </label>

            <form
              id="formEsqueciSenha"
              onSubmit={methods.handleSubmit(handleSubmit)}
            >
              <InputIdCorreios
                type="text"
                id="idCorreios"
                name="idCorreios"
                maxLength="15"
                label={t('cadastro.forms.labels.login')}
                onBlur={handleBlurIdCorreios}
                //disabled={desabilitarIdCorreios}
                {...formMethods}
              />
              <div className="tem-cpf">
                <label className="radio">
                  <Input
                    type="radio"
                    id="tenhoCnpj"
                    name="tenhoCnpj"
                    value="1"
                    checked={tenhoCnpj === '1'}
                    onChange={handleTenhoCnpj}
                    {...formMethods}
                  />
                  <div className="subtitulo-p">
                    {t('cadastro.forms.options.have_cnpj')}
                  </div>
                </label>

                <label className="radio">
                  <Input
                    type="radio"
                    id="naoTenhoCnpj"
                    name="tenhoCnpj"
                    value="0"
                    checked={tenhoCnpj === '0'}
                    onChange={handleTenhoCnpj}
                     {...formMethods} 
                  />
                  <div className="subtitulo-p">
                    {t('cadastro.forms.options.no_cnpj')}
                  </div>
                </label>
              </div>
               {tenhoCnpj === '0' && ( 
                <>
                  <InputCadastro
                    type="text"
                    id="an8"
                    name="an8"
                    label={t('cadastro.forms.labels.an8')}
                    maxLength="8"
                    //onBlur={handleAN8}
                    {...formMethods} 
                  />
                  <InputCadastro
                    type="text"
                    id="numeroContrato"
                    name="numeroContrato"
                    label={t('cadastro.forms.labels.contrato')}
                    maxLength="10"
                    {...formMethods}
                  />
                </>
               )} 
              
               <InputRazaoSocial
                type="text"
                id="nome"
                name="nome"
                placeholder=""
                label={t('cadastro.forms.labels.company_name')}
                {...formMethods}
              />  

              { tenhoCnpj === '1' && ( 
                <> 
                  <InputCpf
                    type="text"
                    id="cpf"
                    name="cpf"
                    placeholder=""                    
                    label={
                      <span style={{ whiteSpace: 'pre-line' }}>
                        {t('cadastro.forms.labels.cpf_representante_legal')}
                      </span>
                     }                                    
                    {...formMethods}
                  />

                  <InputCadastro
                    className="input-data"
                    type="date"
                    id="dataNascimento"
                    name="dataNascimento"
                    label={t('cadastro.forms.labels.nascimento_representante_legal')}               
                    {...formMethods}
                  />
                </>  
             )}  
              
              {/*<InputCadastro
                type="text"
                id="nomeFantasia"
                name="nomeFantasia"
                label="Nome fantasia"
                placeholder=""
                {...formMethods}
              />*/}

              <div className="campo-txt">
                <InputSenha
                  type="password"
                  id="novaSenha"
                  name="novaSenha"
                  placeholder=""
                  label={
                    t('cadastro.forms.labels.password') +
                    ' ' +
                    t('cadastro.messages.validation.password_requirements')
                  }
                  {...formMethods}
                />
                <InputSenha
                  type="password"
                  id="confirmaSenha"
                  name="confirmaSenha"
                  placeholder=""
                  label={t('cadastro.forms.labels.confirm_password')}
                  {...formMethods}
                />
              </div>

              <div className="radio-container">
                <div className="titulo-radio subtitulo-p">
                  <hr />
                  <br />
                  {t('cadastro.messages.info.token_delivery_method')}
                </div>
                <label className="radio">
                  <Input
                    type="radio"
                    id="E"
                    name="meioEnvio"
                    value="E"
                    checked={meioEnvioSelecionado === 'E'}
                    onChange={handleMeioEnvioChange}
                    {...formMethods}
                  />
                  <div className="subtitulo-p">
                    {t('cadastro.forms.options.email_option')}
                  </div>
                </label>

                <label className="radio">
                  <Input
                    type="radio"
                    id="C"
                    name="meioEnvio"
                    value="C"
                    checked={meioEnvioSelecionado === 'C'}
                    onChange={handleMeioEnvioChange}
                    disabled={desabilitarCelular}
                    {...formMethods}
                  />
                  <div className="subtitulo-p">
                    {t('cadastro.forms.options.mobile_option')}
                  </div>
                </label>
              </div>

              <div className="btns-row">
                <button
                  id="btn-voltar"
                  type="button"
                  className="btn-txt"
                  onClick={() => newSession()}
                >
                  {t('cadastro.forms.buttons.cancel')}
                </button>
                <button id="btn-prosseguir" className="btn-pre" type="submit">                  
                  {t('cadastro.forms.buttons.change_password')}
                </button>
              </div>
            </form>

            <hr />
            <h6 className="ainda-problema">
              {t('cadastro.messages.errors.still_problems')}
            </h6>
            <p className="legenda">
              {t('cadastro.messages.info.contact_help')}{' '}
              <a
                href="https://faleconosco.correios.com.br/cadastro/reclamacao-mc"
                className="txt-link"
              >
                {t('cadastro.legal.contact_us')}
              </a>
              . {t('cadastro.messages.info.update_email_pj')}
            </p>
          </div>
        </div>
      ) : (
        <form>
          <div id="finaliza-cadastro" className="conteudo">
            <div id="bem-vindo" className="card bg-superficie elev5">
              <img
                alt={t('cadastro.accessibility.carol_image')}
                id="img-carol-boasvindas"
                src="/images/carol-perfil.png"
              />

              <h2>{t('cadastro.titles.finalize_change')}</h2>

              <p className="txt-finalizacao">
                {t('cadastro.messages.info.finalize_change')}
              </p>
              <div className="campo-txt">
                <InputToken />
              </div>
              <div className="btns-row">
                <button
                  id="btn-reenviar"
                  type="button"
                  className="btn-cont"
                  onClick={reenviaToken}
                >
                  {t('cadastro.forms.buttons.resend_code')}
                </button>

                <button
                  id="btn-finalizar"
                  type="button"
                  className="btn-pre"
                  onClick={alterar}
                >
                  {t('cadastro.forms.buttons.complete')}
                </button>
                <button
                  className="btn-txt btn-fecha-dialog"
                  onClick={() => newSession()}
                >
                  {t('cadastro.forms.buttons.cancel')}
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
};
export default EsqueciSenhaPJ;
